import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57ffc87c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "generate-key-form",
  class: "login-content generate-key--container"
}
const _hoisted_2 = { class: "ibf-h1-larger login-title text-center" }
const _hoisted_3 = { class: "login-subtitle" }
const _hoisted_4 = { class: "text-weight-[600] text-Text/text_high" }
const _hoisted_5 = { class: "pt-8" }
const _hoisted_6 = { class: "pt-8" }
const _hoisted_7 = { class: "login-form items-center" }
const _hoisted_8 = { class: "login-input-fields mt-[30px]" }
const _hoisted_9 = { class: "mt-[124px]" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Skip ")
const _hoisted_11 = {
  id: "login-support-link",
  class: "mt-[28px] underline"
}
const _hoisted_12 = ["href"]

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';
import { useLicenseFileGenerate } from '@/views/login/loginComponents/OS/licenseUploadComponentsLinux/licenseFileGenerate.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'generateKeyForm',
  emits: ["goToLicenseUpload"],
  setup(__props, { emit }: { emit: ({ (e: 'goToLicenseUpload'): void }), expose: any, slots: any, attrs: any }) {

const { generateKey } = useLicenseFileGenerate();
const supportMailUrl = process.env.VUE_APP_SUPPORT_MAIL;

const goToLicenseUpload = () => {
  emit('goToLicenseUpload');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.generateLicenseForm.title.A')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.generateLicenseForm.title.B')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.generateLicenseForm.subtitle.A')), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.generateLicenseForm.subtitle.B')), 1)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.generateLicenseForm.subtitle.C')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.generateLicenseForm.subtitle.D')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(IncrediButton), {
              "data-testid": "generate-license-key--generate-key-button",
              size: "big",
              class: "w-[306px] !rounded-[50px] block !h-[40px] italic text-[15px] !font-gordita-bold-italic",
              design: "primary-green",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(generateKey)(goToLicenseUpload)), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('license.uploadFileComponent.generateKey')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(IncrediButton), {
              "data-testid": "generate-license-key--skip-button",
              size: "big",
              class: "w-[306px] !rounded-[50px] block !h-[40px] !bg-Hovers/hover_grey !text-Text/text_high",
              design: "primary-green",
              onClick: _withModifiers(goToLicenseUpload, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              "data-testid": "generate-license-key--support-link",
              tabindex: "4",
              href: _unref(supportMailUrl)
            }, _toDisplayString(_ctx.$t('login.licenseForm.supportLink')), 9, _hoisted_12)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})